import React, { useEffect, useRef, useState } from "react";
import { RangeSlider } from "rsuite";
import "./opportunitySlider.scss";

const OpportunitySliderExp = (props: any) => {
	const leftPivot = props.leftPivot;
	const rightPivot = props.rightPivot;
	const rebateData = props.rebate;
	const benchmarkData = props?.benchmark;

	// Original points array
	const points = [
		80, 85, 90, 95, 100, 102.5, 105, 107.5, 110, 112.5, 115, 117.5, 120,
		122.5, 125,
	];

	const [value, setValue] = useState<[number, number]>([
		leftPivot <= 75 ? 77.5 : leftPivot,
		rightPivot,
	]);

	useEffect(() => {
		setValue([leftPivot <= 75 ? 77.5 : leftPivot, props.rightPivot]);
	}, [props.rightPivot, rebateData]);

	const calculateRate = (rebateData: any) => {
		if (leftPivot < 80) {
			return (
				(
					(rebateData["0.00%"] + rebateData["rebate_base"]) *
					100
				).toFixed(2) + "%"
			);
		} else if (leftPivot >= 80 && leftPivot < 85) {
			return (
				(
					(rebateData["80.00%"] + rebateData["rebate_base"]) *
					100
				).toFixed(2) + "%"
			);
		} else if (leftPivot >= 85 && leftPivot < 90) {
			return (
				(
					(rebateData["85.00%"] + rebateData["rebate_base"]) *
					100
				).toFixed(2) + "%"
			);
		} else if (leftPivot >= 90 && leftPivot < 95) {
			return (
				(
					(rebateData["90.00%"] + rebateData["rebate_base"]) *
					100
				).toFixed(2) + "%"
			);
		} else if (leftPivot >= 95 && leftPivot < 100) {
			return (
				(
					(rebateData["95.00%"] + rebateData["rebate_base"]) *
					100
				).toFixed(2) + "%"
			);
		} else if (leftPivot >= 100 && leftPivot < 102.5) {
			return (
				(
					(rebateData["100.00%"] + rebateData["rebate_base"]) *
					100
				).toFixed(2) + "%"
			);
		} else if (leftPivot >= 102.5 && leftPivot < 105) {
			return (
				(
					(rebateData["102.50%"] + rebateData["rebate_base"]) *
					100
				).toFixed(2) + "%"
			);
		} else if (leftPivot >= 105 && leftPivot < 107.5) {
			return (
				(
					(rebateData["105.00%"] + rebateData["rebate_base"]) *
					100
				).toFixed(2) + "%"
			);
		} else if (leftPivot >= 107.5 && leftPivot < 110) {
			return (
				(
					(rebateData["107.50%"] + rebateData["rebate_base"]) *
					100
				).toFixed(2) + "%"
			);
		} else if (leftPivot >= 110 && leftPivot < 112.5) {
			return (
				(
					(rebateData["110.00%"] + rebateData["rebate_base"]) *
					100
				).toFixed(2) + "%"
			);
		} else if (leftPivot >= 112.5 && leftPivot < 115) {
			return (
				(
					(rebateData["112.50%"] + rebateData["rebate_base"]) *
					100
				).toFixed(2) + "%"
			);
		} else if (leftPivot >= 115 && leftPivot < 117.5) {
			return (
				(
					(rebateData["115.00%"] + rebateData["rebate_base"]) *
					100
				).toFixed(2) + "%"
			);
		} else if (leftPivot >= 117.5 && leftPivot < 120) {
			return (
				(
					(rebateData["117.50%"] + rebateData["rebate_base"]) *
					100
				).toFixed(2) + "%"
			);
		} else if (leftPivot >= 120 && leftPivot < 122.5) {
			return (
				(
					(rebateData["120.00%"] + rebateData["rebate_base"]) *
					100
				).toFixed(2) + "%"
			);
		} else {
			return (
				(
					(rebateData["122.50%"] + rebateData["rebate_base"]) *
					100
				).toFixed(2) + "%"
			);
		}
	};

	const validateNumbers = (e: any) => {
		return (e.target.value = e.target.value.replace(/[^\d]/g, ""));
	};

	const renderMark = (markValue: number) => {
		if ([75].includes(markValue)) {
			return (
				<div style={{ marginTop: "-4.5vh", marginLeft: "-1vw" }}>
					<span
						style={{
							marginLeft: ".7vw",
							display: "inline-block",
							transform: "translateX(-10%)",
						}}
					>
						0%
					</span>
					<div className="devider">|</div>
				</div>
			);
		} else if (
			leftPivot > 0 &&
			leftPivot <= 75 &&
			[77.5].includes(markValue)
		) {
			return (
				<div style={{ marginTop: "-4.5vh", marginLeft: "-1vw" }}>
					<span
						style={{
							marginInline: "1vh",
							display: "inline-block",
							transform: "translateX(-50%)",
						}}
					>
						{Number(leftPivot).toFixed(2)}%
					</span>
					<div className="devider">|</div>
				</div>
			);
		} else if (points.includes(markValue)) {
			return (
				<div style={{ marginTop: "-4.5vh", marginLeft: "-1vw" }}>
					<span
						style={{
							marginInline: "1vh",
							display: "inline-block",
							transform: "translateX(-50%)",
						}}
					>
						{markValue === 122.5 ? "120+" : markValue}%
					</span>
					<div className="devider">|</div>
					<div
						style={{
							marginTop: "0.5vh",
							color: `${
								Number(
									`${
										rebateData?.[
											`${markValue.toFixed(2)}%`
										] * 100
									}`
								) ===
								Number(
									`${
										benchmarkData?.[
											`${markValue.toFixed(2)}%`
										] * 100
									}`
								)
									? "#d6af15"
									: "black"
							}`,
						}}
					>
						{Number(
							`${rebateData?.[`${markValue.toFixed(2)}%`] * 100}`
						).toFixed(2) + "%"}
					</div>
					<div style={{ marginTop: "2.2vh" }}>
						{Number(
							`${
								benchmarkData?.[`${markValue.toFixed(2)}%`] *
								100
							}`
						).toFixed(2) + "%"}
					</div>
				</div>
			);
		}
		return null;
	};

	return (
		<>
			<div className={`opportunity_slider-wrapper opportunity_slider`}>
				<div className="flex flex-col static-block">
					<div className="flex justify-between w-[100%] h-full items-center">
						<span className="w-full text-center">Supplier</span>
						<span>
							Base <br /> Rebate
						</span>
					</div>
					<div className="vendor_sectionexp">
						<span>
							{rebateData?.master_vendor_name?.length > 12
								? rebateData?.master_vendor_name?.slice(0, 12) +
								  "..."
								: rebateData?.master_vendor_name}
						</span>
						<span
							className="text-center left-2"
							style={{
								color: `${
									(benchmarkData?.rebate_base * 100).toFixed(
										2
									) ===
									(rebateData?.rebate_base * 100).toFixed(2)
										? "#d6af15"
										: "black"
								}`,
							}}
						>
							{(rebateData?.rebate_base * 100).toFixed(2)}%
						</span>
					</div>
					<div className="vendor_sectionexp benchmark_section">
						<span>BEST BENCHMARK</span>
						<span className="text-center left-2">
							{(benchmarkData?.rebate_base * 100).toFixed(2)}%
						</span>
					</div>
				</div>

				<RangeSlider
					min={75}
					defaultValue={value}
					step={2.5}
					max={125}
					graduated
					progress
					value={value}
					handleClassName={`triangle-handle hide-greenHandle`}
					renderMark={renderMark}
					renderTooltip={(markValue: any) => {
						if ([80].includes(markValue)) {
							return <span>0%</span>;
						} else if (
							leftPivot <= 75 &&
							[77.5].includes(markValue)
						) {
							return <span>{Number(leftPivot).toFixed(2)}%</span>;
						} else if (points.includes(markValue)) {
							return <span>{markValue}%</span>;
						} else {
							return <span>{Number(leftPivot).toFixed(2)}%</span>;
						}
					}}
					style={{ width: "100%" }}
					className="m-4"
				/>

				<div className="flex flex-col rate_wrapper">
					<div className="flex justify-between w-[100%] h-full items-center">
						<span className="w-full text-center">Rate</span>
					</div>
					<div className="rate_section">
						<span className="text-center">
							{calculateRate(rebateData)}
						</span>
					</div>
					<div className="rate_section benchmark_section">
						<span className="text-center">
							{calculateRate(benchmarkData)}
						</span>
					</div>
				</div>
			</div>
		</>
	);
};

export default OpportunitySliderExp;
